import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=1ade0853&scoped=true"
import script from "./Add.ts?vue&type=script&lang=ts&external"
export * from "./Add.ts?vue&type=script&lang=ts&external"
import style0 from "./Add.vue?vue&type=style&index=0&id=1ade0853&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ade0853",
  null
  
)

export default component.exports